import { API_SERVICES } from "@/const/api-services";

export const FOXIA_API = {
  FOXIA_BLOGS: (id?: number | string) =>
    `${API_SERVICES.ANALYTIC}/foxia/blogs${id ? `/${id}` : ""}`,
  FOXIA_UPLOAD: () => `${API_SERVICES.ANALYTIC}/foxia/upload`,
  FOXIA_UPLOAD_URL: () => `${API_SERVICES.ANALYTIC}/foxia/upload-by-url`,
};

export const FOXIA_BLOG_API = {
  FOXIA_BLOGS: (id?: number | string) =>
    `${API_SERVICES.ANALYTIC}/foxia/blogs${id ? `/${id}` : ""}`,
};

export const FOXIA_BLOG_TAGS_API = {
  FOXIA_BLOG_TAGS: (id?: number | string) =>
    `${API_SERVICES.ANALYTIC}/foxia/blog-tags${id ? `/${id}` : ""}`,
};

export const FOXIA_BLOG_CATEGORIES_API = {
  FOXIA_BLOG_CATEGORIES: (id?: number | string) =>
    `${API_SERVICES.ANALYTIC}/foxia/blog-categories${id ? `/${id}` : ""}`,
};
